// Determine status card colors based on practice statuses
const red = `danger`;
const blue = `primary`;
const green = `success`;
const grey = `secondary`;

const getHeartbeatStyle = (hasRun, hasError) => {
    if (!hasRun) return grey;

    return hasError ? red : green;
};

const getExtractionStyle = (hasRun, hasError, isStale, isActive) => {
    if (!hasRun) return grey;

    if (isActive) return getRunningStyle();

    if (hasError || isStale) return red;

    return green;
};

const getLoaderStyle = (hasRun, hasError, isActive) => {
    if (!hasRun) return grey;

    if (isActive) return getRunningStyle();

    if (hasError) return red;

    return green;
};

const getRunningStyle = () => {
    return blue;
};

const getMissionControlStyle = (isMissionControlAlive) => {
    if (isMissionControlAlive === undefined || isMissionControlAlive === null)
        return 'text-secondary';

    if (isMissionControlAlive) {
        return 'text-success';
    }
    return 'text-danger';
};

export {
    getHeartbeatStyle,
    getExtractionStyle,
    getLoaderStyle,
    getRunningStyle,
    getMissionControlStyle,
};
